import { Component, Input, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'app-progress-bar',
  standalone: false,
  templateUrl: './progress-bar.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './progress-bar.component.scss',
})
export class ProgressBarComponent {
  @Input() progress: number = 0;
  @Input() max: number = 100;
  @Input() color: string = 'primary';
}
